import {
  Flex,
  FloraButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@grupoboticario/flora-react';
import type { DeleteItemProps } from './DeleteItem.d';
import { DELETE_ITEM_CONST } from './DeleteItem.d';
import { DeleteItem } from './DeleteItem.styles';

import { ResponsiveFloraTypography } from 'ui/components/primitives';
import { theme } from 'ui/theme';
import { ModalCloseButton } from 'ui/components/primitives/ModalCloseButton/ModalCloseButton';

const DeleteItemBase = ({ onClose, onDelete, product, visible }: DeleteItemProps) => {
  const { image, name } = product;

  return (
    <Flex>
      <Modal open={visible}>
        <ModalContent size="large" data-testid={DELETE_ITEM_CONST.TEST_ID}>
          <ModalCloseButton onClose={onClose} />
          <ModalHeader css={{ paddingBottom: 0, minWidth: '100%' }}>
            <div style={{ width: '90%' }}>
              <ResponsiveFloraTypography fontSize="bodyLargeStandard">
                Você tem certeza que deseja remover este produto?
              </ResponsiveFloraTypography>
            </div>
          </ModalHeader>
          <ModalBody
            css={{ paddingTop: `${theme.space['4']}`, paddingBottom: `${theme.space['4']}` }}
          >
            <DeleteItem.Product>
              <DeleteItem.Picture
                alt={image?.title}
                opacity="100"
                ratio="4x3"
                sources={[
                  {
                    srcSet: `${image}`,
                  },
                ]}
                src={image?.url}
              />

              <DeleteItem.Name>{name}</DeleteItem.Name>
            </DeleteItem.Product>
          </ModalBody>
          <ModalFooter css={{ flexDirection: 'column' }}>
            <div>
              <FloraButton isFull onClick={onDelete}>
                Remover
              </FloraButton>
            </div>
            <div>
              <FloraButton isFull hierarchy="secondary" onClick={onClose}>
                Cancelar
              </FloraButton>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default DeleteItemBase;
